import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutTenderGridLayout extends Layout {
    buttonLinkTender: Button;
    buttonPurposeSwap: Button;
    buttonRawData: Button;
    buttonSuggestedPricing: Button;
    panelActionButtons1: Panel;
    panelActionButtons2: Panel;
    panelActionMain: Panel;
    panelSecondaryFilters: Panel;
    sourceEdiOrder: DataSource;
    sourceEdiStop: DataSource;
    sourceLoadTenderExpressRemote: DataSource;
    tableLtx: Table;
}
